import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { getIconColor } from "@/src/services/iconService";

const IconRequirementNotMet = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m84.72,192.97c-1.11-1.11-2.9-1.11-4.01,0l-4.36,4.36-4.36-4.36c-1.11-1.11-2.9-1.11-4.01,0s-1.11,2.9,0,4.01l4.36,4.36-4.36,4.36c-1.11,1.11-1.11,2.9,0,4.01.55.55,1.28.83,2,.83s1.45-.28,2-.83l4.36-4.36,4.36,4.36c.55.55,1.28.83,2,.83s1.45-.28,2-.83c1.11-1.11,1.11-2.9,0-4.01l-4.36-4.36,4.36-4.36c1.11-1.11,1.11-2.9,0-4.01Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m63.82,77.75c-.74,1.38-.22,3.1,1.16,3.84l5.46,2.92c.42.23.88.33,1.33.33.91,0,1.8-.44,2.34-1.24l9.99-14.62c.88-1.29.55-3.06-.74-3.94-1.29-.88-3.06-.55-3.94.74l-8.55,12.52-3.22-1.72c-1.38-.74-3.1-.22-3.84,1.16Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m83.37,107.14c-1.29-.88-3.06-.55-3.94.74l-8.55,12.52-3.22-1.72c-1.38-.74-3.1-.22-3.84,1.16s-.22,3.1,1.16,3.84l5.46,2.92c.42.23.88.33,1.33.33.91,0,1.8-.44,2.34-1.24l9.99-14.62c.88-1.29.55-3.06-.74-3.94Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m83.37,149.23c-1.29-.88-3.06-.55-3.94.74l-8.55,12.52-3.22-1.72c-1.38-.74-3.1-.22-3.84,1.16s-.22,3.1,1.16,3.84l5.46,2.92c.42.23.88.33,1.33.33.91,0,1.8-.44,2.34-1.24l9.99-14.62c.88-1.29.55-3.06-.74-3.94Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m261.05,192.24c-11.56-12.02-26.91-18.26-42.39-18.65V18.49c0-7.01-5.7-12.71-12.7-12.71H62.5c-2.39-.14-18.95-.53-30.11,14.17-10.32,13.6-9.48,24.71-9.1,27.3v206.84c0,7,5.69,12.7,12.69,12.7h129.51c2.19,3.5,4.76,6.83,7.74,9.92,11.28,11.73,26.45,18.36,42.72,18.68.41,0,.81.01,1.22.01,15.82,0,30.77-6.02,42.21-17.02,24.21-23.28,24.97-61.92,1.68-86.13ZM39.16,25.09c6.06-7.99,14.23-10.13,19-10.67v24.04c0,2.31-1.88,4.2-4.19,4.2h-22.34c.29-3.65,1.75-9.96,7.53-17.57Zm121.9,233.19H35.98c-2.31,0-4.18-1.88-4.18-4.19V51.16h22.18c7,0,12.7-5.7,12.7-12.7V14.29h139.29c2.31,0,4.19,1.89,4.19,4.2v155.48c-12.81,1.46-25.26,6.96-35.25,16.57-18.71,17.99-23.4,45.15-13.84,67.74Zm90.82,12.32c-9.66,9.29-22.35,14.25-35.74,14-13.39-.26-25.87-5.72-35.15-15.37-19.17-19.93-18.55-51.74,1.38-70.91,9.71-9.33,22.23-13.97,34.73-13.97,13.17,0,26.33,5.15,36.16,15.37,19.16,19.92,18.54,51.72-1.38,70.88Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m237.44,214.15c-2.1-2.11-5.52-2.11-7.63,0l-12.69,12.69-12.69-12.69c-2.11-2.11-5.52-2.11-7.63,0-2.11,2.11-2.11,5.52,0,7.63l12.69,12.69-12.69,12.69c-2.11,2.11-2.11,5.52,0,7.63,1.05,1.05,2.43,1.58,3.81,1.58s2.76-.53,3.81-1.58l12.69-12.69,12.69,12.69c1.05,1.05,2.43,1.58,3.81,1.58s2.76-.53,3.81-1.58c2.11-2.11,2.11-5.52,0-7.63l-12.69-12.69,12.69-12.69c2.11-2.11,2.11-5.52,0-7.63Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m102.12,125.35h81.82c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-81.82c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m102.12,167.44h81.82c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-81.82c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m102.12,83.26h81.82c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25h-81.82c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m152.26,201.03h-50.14c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25h50.14c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m59.68,93.47h20.61c1.57,0,2.83-1.27,2.83-2.83v-7.31c0-1.57-1.27-2.83-2.83-2.83s-2.83,1.27-2.83,2.83v4.47h-14.94v-14.94h4.47c1.57,0,2.83-1.27,2.83-2.83s-1.27-2.83-2.83-2.83h-7.31c-1.57,0-2.83,1.27-2.83,2.83v20.61c0,1.57,1.27,2.83,2.83,2.83Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m59.68,135.56h20.61c1.57,0,2.83-1.27,2.83-2.83v-7.31c0-1.57-1.27-2.83-2.83-2.83s-2.83,1.27-2.83,2.83v4.47h-14.94v-14.94h4.47c1.57,0,2.83-1.27,2.83-2.83s-1.27-2.83-2.83-2.83h-7.31c-1.57,0-2.83,1.27-2.83,2.83v20.61c0,1.57,1.27,2.83,2.83,2.83Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m59.68,177.65h20.61c1.57,0,2.83-1.27,2.83-2.83v-7.31c0-1.57-1.27-2.83-2.83-2.83s-2.83,1.27-2.83,2.83v4.47h-14.94v-14.94h4.47c1.57,0,2.83-1.27,2.83-2.83s-1.27-2.83-2.83-2.83h-7.31c-1.57,0-2.83,1.27-2.83,2.83v20.61c0,1.57,1.27,2.83,2.83,2.83Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m80.29,210.87c-1.23,0-2.27.78-2.67,1.88h-15.11v-14.94h.35c1.57,0,2.83-1.27,2.83-2.83s-1.27-2.83-2.83-2.83h-3.18c-1.57,0-2.83,1.27-2.83,2.83v20.61c0,1.57,1.27,2.83,2.83,2.83h20.61c1.57,0,2.83-1.27,2.83-2.83v-1.88c0-1.57-1.27-2.83-2.83-2.83Z"
      />
    </SvgIcon>
  );
};

export default IconRequirementNotMet;
